// @flow
import * as React from 'react';
import _ from 'lodash';
import Lock from '../../components/Icons/Lock';
import { CoachPopup } from "../CoachPopup";
import colors from '../../assets/css/colors';

type Props = {
};
type State = {
	coach_open: boolean,
};


export class CoachLockIcon extends React.Component<Props, State> {

	state = {
		coach_open: false,
	};

	constructor(props: Props, state: State) {
		super(props, state);
		_.bindAll(this, [
			'handlePopup',
		]);
	}

	handlePopup() {
		const { coach_open } = this.state;
		this.setState({ coach_open: !coach_open });
	}

	render() {
		if (this.state.coach_open) {
			return (<CoachPopup
				closeClick={this.handlePopup}
			/>);
		}
		return (
			<Lock
				cursor="pointer"
				onClick={this.handlePopup}
				color={colors.coachPurple}
			/>
		);
	}
}

export default CoachLockIcon;


// WEBPACK FOOTER //
// ./src/components/CoachLockIcon/index.js